import script from "./TechAbility.vue?vue&type=script&setup=true&lang=js"
export * from "./TechAbility.vue?vue&type=script&setup=true&lang=js"

import "./TechAbility.vue?vue&type=style&index=0&id=cc2e61f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc2e61f6"]])

export default __exports__